import axios from "./interceptors";
import { PORT_API_CHAT_CONTACTS } from "../config/environment";

export const getContacts = (page, pageSize) => {
  page = page - 1;
  return axios.get(
    `${PORT_API_CHAT_CONTACTS}/api/profile-connections/shared-details/${page}/${pageSize}`
  );
};
